import moment from 'moment';

export default class igOtBooking {

    constructor(igOtBookingWidgetElement){
        this.bwElement = igOtBookingWidgetElement; //Target element for this instance of the code

        this.debugMode = true;
        
        console.log('igOtBooking inits');
        // Define Global Variables
        this.restaurantRid;
        this.partySize;
        this.startDateTime;
        this.cardRequired;
        this.attributes;
        this.reservationAttribute;
        this.reservationToken;
        this.availabilityType;
        this.experiences;
        this.chosenExperience = 'not-set';
        this.chosenExperienceName = 'not-set';
        this.chosenExperienceCost = 'not-set';
        this.addOnData = [];
        this.reset = false;
        this.buttonActive = false,
        this.submitted = false;


        this.bookingWidget();
    }


    bookingWidget() {

        // Init global functions
        this.backBtn();
        this.handleAccordians();
        this.getGuestsAndTimes();
        this.resetBookingWidgetClose();

        const bookATable = this.bwElement.querySelector('#book-a-table');

        let restaurantRidError,
            partySizeError,
            dateError,
            timeError;

        bookATable.addEventListener('click', (e) => {
            e.preventDefault();

            // Set variables
            this.restaurantRid = this.bwElement.querySelector('#restaurant_rid').value;
            this.partySize = this.bwElement.querySelector('#party_size').value;

            let date = this.bwElement.querySelector('#date').value;
            let time = this.bwElement.querySelector('#time').value;
            this.startDateTime = date+'T'+time;

            let anyError = false;

            if (!anyError && (this.restaurantRid == '' || this.restaurantRid == null)) {
                anyError = true;
                restaurantRidError = true;
                this.errorPopup('Please select a restaurant');
            } else {
                restaurantRidError = false;
            }

            if (!anyError && (this.partySize == '' || this.partySize == null)) {
                anyError = true;
                partySizeError = true;
                this.errorPopup('Please select your number of guests');
            } else {
                partySizeError = false;
            }

            if (!anyError && date == '') {
                anyError = true;
                dateError = true;
                this.errorPopup('Please select a date');
            } else {
                dateError = false;
            }

            if (!anyError && (time == '' || time == null)) {
                anyError = true;
                timeError = true;
                this.errorPopup('Please select a time');
            } else {
                timeError = false;
            }

            let timeNow = moment().local().format('YYYYMMDDHHmm');
            let requestedTime = date+' '+time;
            let momentObj = moment(requestedTime, 'YYYY-MM-DD HH:mm');
            let requestedTimeFormat = momentObj.format('YYYYMMDDHHmm');

            if(!anyError && timeNow >= requestedTimeFormat) {
                anyError = true;
                timeError = true;
                this.errorPopup('Your choosen time is in the past');
            } else {
                timeError = false;
            }

            if(restaurantRidError == false && partySizeError == false && dateError == false && timeError == false) {

                if(this.debugMode){
                    console.log('Requesting check_opentable_availability...');
                }

                this.bwElement.classList.add('loading');

                fetch('https://wordpress-1260381-4532312.cloudwaysapps.com/wp-json/route/check-opentable-availability', {
                    method: 'POST',
                    credentials: 'same-origin',
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    body: JSON.stringify({
                        restaurantRid: this.restaurantRid,
                        partySize: this.partySize,
                        startDateTime: this.startDateTime
                    })
                })
                .then((response) => response.json())
                .then((data) => {

                     this.bwElement.classList.remove('loading');

                    if(data.availability == true) {

                        this.selectTableType(data);
                        this.bwElement.querySelector('#booking-type-screen .back-btn').dataset.screen = 'availability-search-screen';

                    } else {

                        if(data.other_availability) {

                            let otherAvailabilityContent = '';
                            let otherAvailability = false;

                            data.other_availability.forEach(addAvailabilityTiles);

                            function addAvailabilityTiles(item, index, arr) {

                                let otherAvailabilityTime = item.time.split('T');
                                let timeNow = moment().format('YYYYMMDDHHmm');
                                let availabilityTime = otherAvailabilityTime[0]+' '+otherAvailabilityTime[1];
                                let momentObj = moment(availabilityTime, 'YYYY-MM-DD HH:mm');
                                let availabilityTimeFormat = momentObj.format('YYYYMMDDHHmm');
                                let tableTypeText = 'Standard';

                                if(item.attributes == 'default') {
                                    tableTypeText = 'Standard';
                                } else {
                                    tableTypeText = item.attributes;
                                }

                                if(timeNow < availabilityTimeFormat) {
                                    otherAvailabilityContent += '<div class="availability-button" data-experiences="'+item.experiences+'" data-availabilitytype="'+item.availability_type+'" data-reservationattribute="'+ item.attributes+'" data-card="'+ item.card+'" data-time="'+item.time+'">'+ otherAvailabilityTime[1] +'</br>'+tableTypeText+'</div>';
                                    otherAvailability = true;
                                }
                            }

                            if(otherAvailability) {
                                this.showBookingScreen('other-availability-screen');
                                this.bwElement.querySelector('.other-availability-list').innerHTML = otherAvailabilityContent;
                                this.bwElement.querySelector('#booking-type-screen .back-btn').dataset.screen = 'other-availability-screen';
                                this.newAvailabilitySelect();

                            } else {
                                this.errorPopup('For alternative reservations, please call 0161 830 4580. <br/> Our central reservations line is open Monday to Friday, 9am–7pm, and Saturdays, 9am–5pm.','Unfortunately, no availability matches your current search.');
                            }

                        } else {
                            this.errorPopup('For alternative reservations, please call 0161 830 4580. <br/> Our central reservations line is open Monday to Friday, 9am–7pm, and Saturdays, 9am–5pm.','Unfortunately, no availability matches your current search.');
                        }
                    }
                })
                .catch((error) => {

                     this.bwElement.classList.remove('loading');

                    console.error(error);
                });  

            } else {
                console.log('error');
            }

        });
    
    } // end bookingWidget

    errorPopup = (content, title = 'Apologies, an error has occurred with your booking.') => {

        this.bwElement.querySelector('.ot-error-popup').classList.add('active');
        this.bwElement.querySelector('.ot-error-popup__title').innerHTML = title;
        this.bwElement.querySelector('.ot-error-popup__content').innerHTML = content;
        
        const bookingScreens = this.bwElement.querySelectorAll('.booking-screen');
        bookingScreens.forEach(bookingScreen => {
            bookingScreen.classList.add('blur');
        });

        document.getElementById('ot-steps').classList.add('blur');

        this.bwElement.querySelector('.ot-error-popup__close').addEventListener('click', (e) => {
            
            e.preventDefault(); 

            this.bwElement.querySelector('.ot-error-popup').classList.remove('active');

            bookingScreens.forEach(bookingScreen => {
                bookingScreen.classList.remove('blur');
            });

            document.getElementById('ot-steps').classList.remove('blur');
        });
    }


    newAvailabilitySelect = () => {

        const availabilityButtons = this.bwElement.querySelectorAll('.availability-button');
        const reserveNewTime = this.bwElement.querySelector('#reserve-new-time');

        availabilityButtons.forEach(availabilityButton => {
            
            availabilityButton.addEventListener('click', (e) => {
                e.preventDefault(); 

                availabilityButtons.forEach(availabilityButton => {
                    availabilityButton.classList.remove('active');
                });

                e.currentTarget.classList.add('active');
                
                // Update global variables
                this.startDateTime = e.currentTarget.dataset.time;
                this.cardRequired = e.currentTarget.dataset.card;
                this.reservationAttribute = e.currentTarget.dataset.reservationattribute;
                this.availabilityType = e.currentTarget.dataset.availabilitytype;
                this.experiences = e.currentTarget.dataset.experiences;

                reserveNewTime.classList.remove('disabled');       
            });
        });

        reserveNewTime.addEventListener('click', (e) => {
            e.preventDefault();

            let otherAvailabilityTime = this.startDateTime.split('T');
            let timeNow = moment().format('YYYYMMDDHHmm');
            let availabilityTime = otherAvailabilityTime[0]+' '+otherAvailabilityTime[1];
            let momentObj = moment(availabilityTime, 'YYYY-MM-DD HH:mm');
            let availabilityTimeFormat = momentObj.format('YYYYMMDDHHmm');

            if(timeNow < availabilityTimeFormat) {

                this.bwElement.querySelector('#your-details-screen .back-btn').dataset.screen = "availability-search-screen";

                if(this.availabilityType.includes("Experience")) {
                    this.selectExperienceType();
                } else {
                    this.createOpentableSlotLock();
                }

            } else {
                this.errorPopup('Your choosen time is in the past');
            }
        }, {once : true});
    }// end newAvailabilitySelect



    selectTableType = (data) => {

        let tableTypes = data.times_available,
        tableTypesContent = '',
        tableTypeText = 'Standard';

        tableTypes.forEach(addTableTypes);

        function addTableTypes(item, index, arr) {

            if(item.attributes == 'default') {
                tableTypeText = 'Standard';
            } else {
                tableTypeText = item.attributes;
            }

            tableTypesContent += '<div class="ot-col col-6"><h2>'+tableTypeText+'</h2></div><div class="ot-col col-6 | flex justify-end">\
            <div id="select_table" data-experiences="'+item.experiences+'" data-availabilitytype="'+item.availability_type+'" data-reservationattribute="'+ item.attributes+'" data-card="'+ item.card+'" class="igOtBw-button">Select</div></div>';
        }

        this.bwElement.querySelector('.table-types').innerHTML = tableTypesContent;

        const bookingScreens = this.bwElement.querySelectorAll('.booking-screen');
        bookingScreens.forEach(bookingScreen => {
            bookingScreen.classList.remove('active');
        });

        this.bwElement.querySelector('#booking-type-screen').classList.add('active');

        const bookingSteps = this.bwElement.querySelectorAll('.ot-step');
        bookingSteps.forEach(bookingStep => {
            bookingStep.classList.remove('active');
        });

        this.bwElement.querySelector('#step-2').classList.add('active');

        const restaurantSelect = this.bwElement.querySelector('#restaurant_rid');
        const restaurantText= restaurantSelect.options[restaurantSelect.selectedIndex].text;
        this.bwElement.querySelector('#booking-type-screen .booking-details__location').innerText = restaurantText;

        const dateTime = this.startDateTime.split('T');

        const formatDate = moment(this.startDateTime).format('dddd, MMMM D');
        this.bwElement.querySelector('#booking-type-screen .booking-details__info--time').innerText = dateTime[1];
        this.bwElement.querySelector('#booking-type-screen .booking-details__info--date').innerText = formatDate;
        this.bwElement.querySelector('#booking-type-screen .booking-details__info--guests').innerText = this.partySize+' Guests';

        const selectTableButtons = this.bwElement.querySelectorAll('.table-types .igOtBw-button');

        selectTableButtons.forEach(selectTableButton => {
            
            selectTableButton.addEventListener('click', (e) => {
                e.preventDefault(); 

                this.reservationAttribute = e.currentTarget.dataset.reservationattribute;
                this.cardRequired = e.currentTarget.dataset.card;
                this.availabilityType = e.currentTarget.dataset.availabilitytype;
                this.experiences = e.currentTarget.dataset.experiences;

                this.bwElement.querySelector('#your-details-screen .back-btn').dataset.screen = "booking-type-screen";

                if(this.availabilityType.includes("Experience")) {
                    this.selectExperienceType();
                } else {
                    this.createOpentableSlotLock();
                }
            });
        });
    }//end selectTableType

    selectExperienceType = () => {

        if(this.debugMode){
            console.log('Requesting get_opentable_experiences...');
            console.log('availabilityType');
            console.log(this.availabilityType);
        }

        const dateTime = this.startDateTime.split('T');
        const formatDate = moment(this.startDateTime).format('dddd, MMMM D');
        this.bwElement.querySelector('#experiences-screen .booking-details__info--time').innerText = dateTime[1];
        this.bwElement.querySelector('#experiences-screen .booking-details__info--date').innerText = formatDate;
        this.bwElement.querySelector('#experiences-screen .booking-details__info--guests').innerText = this.partySize+' Guests';

        let tableTypeText = 'Standard;'

        if(this.reservationAttribute == 'default') {
            tableTypeText = 'Standard';
        } else {
            tableTypeText = this.reservationAttribute;
        }

        this.bwElement.querySelector('#experiences-screen .booking-details__info--type').innerText = tableTypeText;

        this.bwElement.classList.add('loading');

        fetch('https://wordpress-1260381-4532312.cloudwaysapps.com/wp-json/route/get-opentable-experiences', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: JSON.stringify({
                restaurantRid: this.restaurantRid,
                experiences: this.experiences
            })
        })
        .then((response) => response.json())
        .then((data) => {

            this.bwElement.classList.remove('loading');

            let experienceContent = '';

            data.forEach(addExperienceTiles);

            function addExperienceTiles(item, index, arr) {
            
                let cost = '';
                if (item.min_unit_amount !== null) {
                    cost = (item.min_unit_amount / item.multiplier).toFixed(2);
                }

                experienceContent += '<div class="experience-tile">\
                    <div class="experience-tile__content">\
                        <h4>'+ item.name +'</h4>\
                        ' + (cost !== '' ? '<p class="experience-tile__content--cost">£'+ cost +' - per person</p>' : '') + '\
                        <p>'+ item.description +'</p>\
                    </div>\
                    <div id="add_experience" data-addon="'+item.add_ons+'" data-cost="'+cost+'" data-cardrequired="'+item.pre_payment_required+'" data-experience="'+item.id+','+item.version+'" data-experiencename="'+item.name+'" class="igOtBw-button">Add</div>\
                </div>';
            }

            this.bwElement.querySelector('#experiences-screen .experiences').innerHTML = experienceContent;

            if(this.availabilityType == 'Experience') {
                document.querySelector('#experiences-screen #skip-to-standard').style.display = "none";
            }

            this.showBookingScreen('experiences-screen');
            this.addExperienceButton();
            this.skipToStandardButton();

        })
        .catch((error) => {
            this.bwElement.classList.remove('loading');
            console.error(error);
        });
    }//end selectExperienceType


    addExperienceButton = () => {

        const experienceButtons = this.bwElement.querySelectorAll('.experience-tile .igOtBw-button');

        experienceButtons.forEach(experienceButton => {
            
            experienceButton.addEventListener('click', (e) => {
                e.preventDefault(); 

                this.chosenExperience = e.currentTarget.dataset.experience;
                this.chosenExperienceName = e.currentTarget.dataset.experiencename;
                this.chosenExperienceCost = e.currentTarget.dataset.cost;

                if(e.currentTarget.dataset.cardrequired == true || e.currentTarget.dataset.cardrequired == 'true') {
                    this.cardRequired = true;
                }

                // DISABLED ADD ONS FOR NOW
                // if(e.currentTarget.dataset.addon == 'true') {
                //     this.selectAddOn();
                // } else {
                //     this.createOpentableSlotLock();
                // }

                this.createOpentableSlotLock();
            });
        });
    }//end addExperienceButton


    selectAddOn = () => {

        if(this.debugMode){
            console.log('Requesting get_opentable_experiences...');
        }

        this.bwElement.classList.add('loading');

        fetch('https://wordpress-1260381-4532312.cloudwaysapps.com/wp-json/route/get-opentable-experiences', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: JSON.stringify({
                restaurantRid: this.restaurantRid,
                experiences: this.experiences
            })
        })
        .then((response) => response.json())
        .then((data) => {

            this.bwElement.classList.remove('loading');

            let addOnContent = '';
            let chosenExperienceId = this.chosenExperience.split(",");

            data.forEach(addOnTiles);

            function addOnTiles(item, index, arr) {

                if(item.id == chosenExperienceId[0]) {
                    item.add_on.forEach(tiles);

                    function tiles(item, index, arr) {

                        addOnContent += '<div class="add-on-tile"><h4>'+ item.name +'</h4>\
                        <input id="'+item.id+'" type="hidden" name="add-on-qty" value="1"/>\
                        <div class="qty-counter">\
                            <p>Quantity</p>\
                            <span data-addonid="'+item.id+'" data-max="'+item.max_per_reservation+'" data-index="'+index+'" data-type="decrease" class="qty-button disabled decrease">-</span>\
                            <div id="'+index+'" class="qty-tracker">1</div>\
                            <span data-addonid="'+item.id+'" data-max="'+item.max_per_reservation+'" data-index="'+index+'" data-type="increase" class="qty-button increase">+</span>\
                        </div>\
                        <div class="button-container">\
                            <div data-addonid="'+item.id+'" data-type="add" class="igOtBw-button">Add</div>\
                            <div data-addonid="'+item.id+'" data-type="remove" class="igOtBw-button disabled">Remove</div></div>\
                        </div>';
                    }
                }
            }

            this.bwElement.querySelector('#add-ons-screen .add-ons').innerHTML = addOnContent;

            this.showBookingScreen('add-ons-screen');
            this.qtyCounter();
            this.addAddOnButton();
            this.skipToStandardButton();
            this.proceedToDetailsButtons();

        })
        .catch((error) => {
            this.bwElement.classList.remove('loading');

            console.error(error);
        });
    }//end selectAddOn


    qtyCounter = () => {

        const qtyCounterButtons = this.bwElement.querySelectorAll('.qty-button');

        qtyCounterButtons.forEach(qtyCounterButton => {
        
            qtyCounterButton.addEventListener('click', (e) => {
                e.preventDefault(); 

                let addOnQty;

                if(e.currentTarget.dataset.type == 'increase') {
                    
                    addOnQty = parseInt(document.getElementById(e.currentTarget.dataset.addonid).value);
                    addOnQty = addOnQty += 1;

                    if(e.currentTarget.dataset.max == addOnQty) {
                        e.currentTarget.classList.add('disabled');
                    }

                    if(addOnQty > 1) {
                        e.currentTarget.parentElement.querySelector('.qty-button.decrease').classList.remove('disabled');
                    }

                    document.getElementById(e.currentTarget.dataset.index).innerHTML = addOnQty;
                }

                if(e.currentTarget.dataset.type == 'decrease') {
                    
                    addOnQty = parseInt(document.getElementById(e.currentTarget.dataset.addonid).value);
                    addOnQty = addOnQty -= 1;

                    if(addOnQty == 1) {
                        e.currentTarget.classList.add('disabled');
                    }

                    if(e.currentTarget.dataset.max < 20) {
                        e.currentTarget.parentElement.querySelector('.qty-button.increase').classList.remove('disabled');
                    }

                    document.getElementById(e.currentTarget.dataset.index).innerHTML = addOnQty;
                }

                document.getElementById(e.currentTarget.dataset.addonid).value = addOnQty;
            });
        });
    }//end qtyCounter


    addAddOnButton = () => {

        const addOnButtons = this.bwElement.querySelectorAll('.add-on-tile .igOtBw-button');

        addOnButtons.forEach(addOnButton => {
        
            addOnButton.addEventListener('click', (e) => {
                e.preventDefault(); 

                let addOnQty;

                //this.bwElement.querySelector('#add-ons-screen #skip-to-standard').style.display = "none";
                this.bwElement.querySelector('#add-ons-screen #proceed-to-details').style.display = "block";

                if(e.currentTarget.dataset.type == 'add') {
                    addOnQty = parseInt(document.getElementById(e.currentTarget.dataset.addonid).value);

                    let addOnDataPush = {};
                    addOnDataPush['id'] = e.currentTarget.dataset.addonid;
                    addOnDataPush['qty'] = addOnQty;
                    this.addOnData.push(addOnDataPush);

                    e.currentTarget.classList.add('disabled');
                    e.currentTarget.nextElementSibling.classList.remove('disabled');
                }

                if(e.currentTarget.dataset.type == 'remove') {

                    this.addOnData = this.addOnData.filter(function(item){ return item.id != e.currentTarget.dataset.addonid});

                    e.currentTarget.classList.add('disabled');
                    e.currentTarget.previousElementSibling.classList.remove('disabled');
                }
            });
        });
    }//end addAddOnButton


    proceedToDetailsButtons = () => {

        const proceedToDetails = this.bwElement.querySelector('#proceed-to-details');

        proceedToDetails.addEventListener('click', (e) => {
            e.preventDefault();
            this.createOpentableSlotLock();
        }, {once : true});
    }//end proceedToDetailsButtons


    skipToStandardButton = () => {

        const skipToStandard = this.bwElement.querySelector('#skip-to-standard');

        skipToStandard.addEventListener('click', (e) => {
            e.preventDefault();
            this.createOpentableSlotLock();
        }, {once : true});
    }//end skipToStandardButton


    createOpentableSlotLock = () => {

        if(this.debugMode){
            console.log('Requesting create_reservation_slot_lock...');
        }
        this.bwElement.classList.add('loading');

        fetch('https://wordpress-1260381-4532312.cloudwaysapps.com/wp-json/route/create-reservation-slot-lock', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            },
            body: JSON.stringify({
                restaurantRid: this.restaurantRid,
                partySize: this.partySize,
                startDateTime: this.startDateTime,
                reservationAttribute: this.reservationAttribute,
                experience: this.chosenExperience
            })
        })
        .then((response) => response.json())
        .then((data) => {

            this.bwElement.classList.remove('loading');

            var fiveMinutes = 60 * 5,
            display = this.bwElement.querySelector('#countdown-time');
            this.startTimer(fiveMinutes, display);

            this.reservationToken = data.token;
           
            this.createOpentableReservation();
        })
        .catch((error) => {
            this.bwElement.classList.remove('loading');
            console.error(error);
        });  
    }//end createOpentableSlotLock


    createOpentableReservation = () => {

        if(this.cardRequired == 'true' || this.cardRequired == true) {
            this.cardRequired = true;
        }

        if(this.cardRequired == true) {
            this.bwElement.querySelector('#card-details').style.display = "block";
        } else {
            this.bwElement.querySelector('#card-details').style.display = "none";
        }

        this.showBookingScreen('your-details-screen');

        const restaurantSelect = this.bwElement.querySelector('#restaurant_rid');
        let restaurantText = restaurantSelect.options[restaurantSelect.selectedIndex].text;

        if(this.chosenExperienceName !== 'not-set') {
            restaurantText = restaurantText+' - '+this.chosenExperienceName;

            this.bwElement.querySelector('#experience-details').style.display = "block";
            this.bwElement.querySelector('#experience-title').innerText = this.chosenExperienceName;

            let totalCost = this.chosenExperienceCost * this.partySize;
            this.bwElement.querySelector('#experience-total').innerText = '£' + totalCost;
            this.bwElement.querySelector('#experience-breakdown').innerText = this.partySize + 'x £' + this.chosenExperienceCost;

            console.log(totalCost);

            if(totalCost == 0) {
                this.bwElement.querySelector('#experience-total').style.display = "none";
                this.bwElement.querySelector('#experience-breakdown').style.display = "none";
            } else {
                this.bwElement.querySelector('#experience-total').style.display = "block";
                this.bwElement.querySelector('#experience-breakdown').style.display = "block";
            }

        } else {
             this.bwElement.querySelector('#experience-details').style.display = "none";
        }

        this.bwElement.querySelector('#your-details-screen .booking-details__location').innerText = restaurantText;

        const dateTime = this.startDateTime.split('T');
        const formatDate = moment(this.startDateTime).format('dddd, MMMM D');
        this.bwElement.querySelector('#your-details-screen .booking-details__info--time').innerText = dateTime[1];
        this.bwElement.querySelector('#your-details-screen .booking-details__info--date').innerText = formatDate;
        this.bwElement.querySelector('#your-details-screen .booking-details__info--guests').innerText = this.partySize+' Guests';

        let tableTypeText = 'Standard;'

        if(this.reservationAttribute == 'default') {
            tableTypeText = 'Standard';
        } else {
            tableTypeText = this.reservationAttribute;
        }

        this.bwElement.querySelector('#your-details-screen .booking-details__info--type').innerText = tableTypeText;
        
        const confirmBooking = this.bwElement.querySelector('#confirm-booking');

        if(this.reset != true) {
            this.buttonActive = true;
            this.submitted = false;
            confirmBooking.addEventListener('click', (e) => {

                e.preventDefault();

                const reservationsPopup = document.querySelector('#reservations .popup__wrapper');
                reservationsPopup.scrollIntoView({ behavior: 'smooth', block: 'start' });

                const firstName = this.bwElement.querySelector('#first_name').value;
                const lastName = this.bwElement.querySelector('#last_name').value;
                const emailAddress = this.bwElement.querySelector('#email_address').value;
                const telephoneNumber = this.bwElement.querySelector('#telephone_number').value;
                const countryCode = this.bwElement.querySelector('#country_code').value;
                const notes = this.bwElement.querySelector('#additional_notes').value;

                let firstNameError = false,
                lastNameError = false,
                emailAddressError = false,
                telephoneNumberError = false,
                creditCardError = false,
                anyError = false;

                if (!anyError && (firstName == '' || firstName == null)) {
                    anyError = true;
                    firstNameError = true;
                    this.errorPopup('Please enter your first name');
                } else {
                    firstNameError = false;
                }

                if (!anyError && (lastName == '' || lastName == null)) {
                    anyError = true;
                    lastNameError = true;
                    this.errorPopup('Please enter your last name');
                } else {
                    lastNameError = false;
                }

                if (!anyError) {
                    const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

                    if (emailAddress === '' || emailAddress === null) {
                        anyError = true;
                        emailAddressError = true;
                        this.errorPopup('Please enter your email address');
                    } else if (!emailPattern.test(emailAddress)) {
                        anyError = true;
                        emailAddressError = true;
                        this.errorPopup('Please enter a valid email address');
                    } else {
                        emailAddressError = false;
                    }
                }

                if (!anyError) {
                    if (telephoneNumber === '' || telephoneNumber === null) {
                        anyError = true;
                        telephoneNumberError = true;
                        this.errorPopup('Please enter your phone number');
                    } else if (isNaN(telephoneNumber) || !/^\d+$/.test(telephoneNumber)) {
                        anyError = true;
                        telephoneNumberError = true;
                        this.errorPopup('Please enter a valid phone number containing only digits');
                    } else {
                        telephoneNumberError = false;
                    }
                }

                //Compile any selected allergens into a string
                const allergens = this.bwElement.querySelectorAll('input[name="allergen"]');
                let allergensNote = '';
                allergens.forEach(allergen => {
                        
                    if(allergen.checked) {
                        allergensNote += allergen.value+' ';
                    }
                });

                 //Compile any selected occasions into a string
                const occasions = this.bwElement.querySelectorAll('input[name="occasion"]');
                let occasionsNote = '';
                occasions.forEach(occasion => {
                        
                    if(occasion.checked) {
                        occasionsNote += occasion.value+' ';
                    }
                });

                let specialRequest = '';

                if(notes && allergensNote) {
                    specialRequest = 'Allergens: '+allergensNote+' - Notes: '+notes;
                } else if(notes && !allergensNote) {
                    specialRequest = notes;
                } else if(!notes && allergensNote) {
                    specialRequest = 'Allergens: '+allergensNote;
                } else {
                    specialRequest = notes;
                }

                if(occasionsNote){
                    specialRequest = specialRequest+' - Occasions: '+occasionsNote;
                }

                const emailOptIn = this.bwElement.querySelector('input[name="email-opt-in"]')
                let restaurantEmailMarketingOptIn = 'false';
                
                if(emailOptIn.checked) {
                    restaurantEmailMarketingOptIn = 'true';
                }

                let cardNumber = 'not-required';
                let expMonth = 'not-required';
                let expYear = 'not-required';
                let cvc = 'not-required';
                let creditCardRequired = 'false';

                if(this.cardRequired === true) {
                    cardNumber = this.bwElement.querySelector('#card_number').value.replace(/\s+/g, '');
                    expMonth = this.bwElement.querySelector('#exp_month').value;
                    expYear = this.bwElement.querySelector('#exp_year').value;
                    cvc = this.bwElement.querySelector('#cvc').value;
                    creditCardRequired = 'true';

                    if (cardNumber == '' || expYear == '' || cvc == '') {
                        creditCardError = true;
                        this.errorPopup('Please enter your card details');
                    } else {
                        creditCardError = false;
                    }

                } else {
                    creditCardRequired = 'false';
                    creditCardError = false;
                }

                if(firstNameError == false && lastNameError == false && emailAddressError == false && telephoneNumberError == false && creditCardError == false && this.submitted == false) {

                    this.submitted = true;
                    
                    if(this.debugMode){
                        console.log('Requesting create_opentable_reservation...');
                    }
                    this.bwElement.classList.add('loading');

                    let reservationData = JSON.stringify({
                        restaurantRid: this.restaurantRid,
                        reservationToken: this.reservationToken,
                        reservationAttribute: this.reservationAttribute,
                        experience: this.chosenExperience,
                        addon: JSON.stringify(this.addOnData),
                        cardRequired: creditCardRequired,
                        firstName: firstName,
                        lastName: lastName,
                        emailAddress: emailAddress,
                        telephoneNumber: telephoneNumber,
                        countryCode: countryCode,
                        specialRequest: specialRequest,
                        restaurantEmailMarketingOptIn: restaurantEmailMarketingOptIn,
                        cardNumber: cardNumber,
                        expMonth: expMonth,
                        expYear: expYear,
                        cvc: cvc,
                    })

                    const makeReservation = (reservationData) => {

                        fetch('https://wordpress-1260381-4532312.cloudwaysapps.com/wp-json/route/create-opentable-reservation', {
                            method: 'POST',
                            credentials: 'same-origin',
                            headers: {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            },
                            body: reservationData
                        })
                        .then((response) => response.json())
                        .then((data) => {

                            console.log(data.error);

                            if(data.error) {

                                if(data.error == 'DinerHasOverlappingReservations - Request violated business rule: DinerHasOverlappingReservations') {

                                    this.bwElement.classList.remove('loading');
                                    this.errorPopup('Overlapping Reservation Already Exists. Please contact us directly if this error persists.');

                                } else if(data.error.includes('IllegalPhoneNumberLength')) {

                                    this.bwElement.classList.remove('loading');
                                    this.errorPopup('Your phone number is not the correct length, please check and try again');

                                } else if(data.error.includes('[Email] Email address')) {

                                    this.bwElement.classList.remove('loading');
                                    this.errorPopup('Email address is not in the correct format, please check and try again');

                                } else if(data.error == 'ValidationError - illegal CreditCard Token = null') {

                                    this.bwElement.classList.remove('loading');
                                    this.errorPopup('Incorrect card details, please try again.');

                                } else if(data.error == 'CreditCardTokenSCARequired - SCAForPayment') {

                                    this.bwElement.classList.add('loading');

                                    var stripe = Stripe(data.connected_account_pk);
                                    var self = this;

                                    stripe.confirmCardPayment(data.client_secret, {
                                        // No data needs to be sent
                                    })
                                    .then(function(result) {
                                        
                                        if(result.paymentIntent) {

                                            reservationData = JSON.parse(reservationData);

                                            reservationData.token = data.stripe_token;
                                            reservationData.last4 = data.last4;
                                            reservationData.paymentMethod = data.payment_method;
                                            reservationData.paymentIntent = result.paymentIntent.id;
                                            reservationData.cardRequired = 'sca-payment';

                                            reservationData = JSON.stringify(reservationData);

                                            makeReservation(reservationData);
                                        }

                                        if(result.error) {
                                            self.bwElement.classList.remove('loading');
                                            self.errorPopup(result.error.message);
                                        }
                                    });

                                } else if(data.error == 'CreditCardTokenSCARequired - SCAForCardVault - SCA required') {

                                    this.bwElement.classList.add('loading');

                                    var stripe = Stripe(data.connected_account_pk);
                                    var self = this;

                                    stripe.confirmCardSetup(data.client_secret, {
                                        // No data needs to be sent
                                    })
                                    .then(function(result) {
                                        
                                        if(result.setupIntent) {

                                            reservationData = JSON.parse(reservationData);

                                            reservationData.token = data.stripe_token;
                                            reservationData.last4 = data.last4;
                                            reservationData.paymentMethod = data.payment_method;
                                            reservationData.setupIntent = result.setupIntent.id;
                                            reservationData.cardRequired = 'sca-setup';

                                            reservationData = JSON.stringify(reservationData);

                                            makeReservation(reservationData);
                                        }

                                        if(result.error) {
                                            self.bwElement.classList.remove('loading');
                                            self.errorPopup(result.error.message);
                                        }
                                    });

                                } else {
                                    this.bwElement.classList.remove('loading');
                                    this.errorPopup(data.error);
                                }
                                
                                this.submitted = false;

                            } else {

                                 this.bwElement.classList.remove('loading');
                                //Successful booking! Show booking confirmation screen
                                this.showBookingScreen('confirmation-screen');

                                const formatDate = moment(data.date_time).format('dddd, MMMM D');
                                const formatTime = moment(data.date_time).format('HH:mm');

                                const manageURL = document.createElement('a');
                                manageURL.href = data.manage_reservation_url;
                                manageURL.classList.add('igOtBw-button');
                                manageURL.innerText = 'Manage Reservation';

                                this.bwElement.querySelector('#message').querySelector('.confirmation-info__copy').innerText = data.message;
                                this.bwElement.querySelector('#confirmation_number').querySelector('.confirmation-info__copy').innerText = data.confirmation_number;
                                this.bwElement.querySelector('#confirmation_date_time').querySelector('.confirmation-info__copy').innerText = formatDate.concat(' - ', formatTime);
                                this.bwElement.querySelector('#comfirmation_party_size').querySelector('.confirmation-info__copy').innerText = data.party_size;

                                if(data.notes !== '') {
                                    this.bwElement.querySelector('#notes').querySelector('.confirmation-info__copy').innerText = data.notes;
                                } else {
                                    this.bwElement.querySelector('#notes').style.display = 'none';
                                }
                                
                                let manageURLContainer = this.bwElement.querySelector('#manage_reservation_url');
                                manageURLContainer.replaceChild(manageURL, manageURLContainer.firstChild);
                            
                                //Add watcher on reset button
                                document.querySelector('#confirmation-reset').addEventListener('click', (e) => {
                                    e.preventDefault();
                                    this.resetBookingWidget();
                                })  
                            }
                        })
                        .catch((error) => {
                            this.bwElement.classList.remove('loading');
                            console.error(error);
                            this.submitted = false;
                        });
                    }

                    makeReservation(reservationData);
                }
            });
        }



    }//end createOpentableReservation


    showBookingScreen = (screen) => {

        const bookingScreens = this.bwElement.querySelectorAll('.booking-screen');
        bookingScreens.forEach(bookingScreen => {
            bookingScreen.classList.remove('active');
        });
            
        document.getElementById(screen).classList.add('active');

        const bookingSteps = this.bwElement.querySelectorAll('.ot-step');
        bookingSteps.forEach(bookingStep => {
            bookingStep.classList.remove('active');
        });

        let stepNumber = '';

        if(screen == 'availability-search-screen' || screen == 'other-availability-screen') {
            stepNumber = 'step-1';
        } else if(screen == 'booking-type-screen') {
            stepNumber = 'step-2';
        } else if(screen == 'experiences-screen' || screen == 'add-ons-screen') {
            stepNumber = 'step-3';
        } else if(screen == 'your-details-screen') {
            stepNumber = 'step-4';

            // Get credit card message
            const formData = new FormData();
            formData.append('restaurantRid', this.restaurantRid);
            formData.append('action', 'get_guests_and_times');
                            
            const restaurantData = new URLSearchParams(formData);

            fetch(igniteAjax.ajaxurl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                },
                body: restaurantData
            })
            .then((response) => response.json())
            .then((data) => {
                this.bwElement.querySelector('#card-details-message').innerText = data.credit_card_message;
            })
            .catch((error) => {
                console.error(error);
            }); 


            const reservationsPopup = document.querySelector('#reservations .popup__wrapper');
            reservationsPopup.scrollIntoView({ behavior: 'smooth', block: 'start' });


        } else if(screen == 'confirmation-screen') {
            stepNumber = false;
        }

        if(stepNumber) {
            document.getElementById('ot-steps').style.display = 'block';
            document.querySelector('.js-ot-title').style.display = 'block';
            document.querySelector('.js-ot-text').style.display = 'block';
            document.getElementById(stepNumber).classList.add('active');
        } else {
            document.getElementById('ot-steps').style.display = 'none';
            document.querySelector('.js-ot-title').style.display = 'none';
            document.querySelector('.js-ot-text').style.display = 'none';
        }
        
    }//end showBookingScreen


    backBtn = () => {
        const backBtns = this.bwElement.querySelectorAll('.back-btn');

        backBtns.forEach(backBtn => {
            
            backBtn.addEventListener('click', (e) => {
                e.preventDefault(); 
                
                this.showBookingScreen(e.currentTarget.dataset.screen);

                if(e.currentTarget.dataset.screen == 'availability-search-screen') {
                    // reset all variables if we return back to first screen
                    this.restaurantRid = '';
                    this.partySize = '';
                    this.startDateTime = '';
                    this.cardRequired = '';
                    this.attributes = '';
                    this.reservationAttribute = '';
                    this.availabilityType = '';
                    this.experiences = '';
                    this.chosenExperience = 'not-set';
                    this.chosenExperienceName = 'not-set';
                    this.addOnData = [];

                    if(this.buttonActive == true) {
                        this.reset = true;
                    }
                }

                if(e.currentTarget.dataset.screen == 'booking-type-screen') {
                    this.experiences = '';
                    this.chosenExperience = 'not-set';
                    this.chosenExperienceName = 'not-set';
                    this.addOnData = [];

                    if(this.buttonActive == true) {
                        this.reset = true;
                    }
                }

                if(e.currentTarget.dataset.screen == 'experiences-screen') {
                    this.experiences = '';
                    this.chosenExperience = 'not-set';
                    this.chosenExperienceName = 'not-set';
                    this.addOnData = [];
                }
            });
        });
    }//end backBtn


    handleAccordians = () => { //Function to handle opening and closing of the allergen & tags/occasions accordian toggles

        let accordianToggles = this.bwElement.querySelectorAll('.js__ot-widget-accordian-toggle');

        if(accordianToggles){
            accordianToggles.forEach((toggle) => {
                toggle.addEventListener('click',(e) => {
                    e.preventDefault();
                    if(toggle.dataset.accordian){
                        let targetAccordian = this.bwElement.querySelector('[data-accordian="' + toggle.dataset.accordian + '"].js__ot-widget-accordian');
                        if(targetAccordian){
                            //Toggle the accordian element
                            if(targetAccordian.classList.contains('active')){
                                targetAccordian.classList.remove('active');
                            }else{
                                targetAccordian.classList.add('active');
                            }
                            //Toggle the trigger element too
                            if(toggle.classList.contains('active')){
                                toggle.classList.remove('active');
                            }else{
                                toggle.classList.add('active');
                            }
                        }
                    }
                })
            })
        }


    }//End handleAccordians

    resetBookingWidgetClose = () => {

        const closeButtons = document.querySelectorAll('.js__close-popups');
        closeButtons.forEach(button => {
            button.addEventListener('click', () => {
                this.resetBookingWidget();
            });
        });
    }

    getGuestsAndTimes = () => {

        const restaurantSelect = this.bwElement.querySelector('#restaurant_rid');
            
        restaurantSelect.addEventListener('change', (e) => {
            e.preventDefault();

            const restaurantRidSelect = e.target.value;

            const formData = new FormData();
            formData.append('restaurantRid', restaurantRidSelect);
            formData.append('action', 'get_guests_and_times');
                            
            const restaurantData = new URLSearchParams(formData);

            if(this.debugMode){
                console.log('Requesting get_guests_and_times...');
            }
            this.bwElement.classList.add('loading');

            fetch(igniteAjax.ajaxurl, {
                method: 'POST',
                credentials: 'same-origin',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'Cache-Control': 'no-cache',
                },
                body: restaurantData
            })
            .then((response) => response.json())
            .then((data) => {

                this.bwElement.classList.remove('loading');

                // Update number of guests
                const partySizeSelect = this.bwElement.querySelector('#party_size'); 

                while (partySizeSelect.options.length > 0) {
                    partySizeSelect.remove(0);
                }

                for (let i = data.min_guests; i <= data.max_guests; i++) {
                    let partySizeOption = new Option(i,i);
                    partySizeSelect.add(partySizeOption, undefined);
                }

                // Update time slots
                const timeSelect = this.bwElement.querySelector('#time'); 

                //Remove the default timeslotes
                while (timeSelect.options.length > 0) {
                    timeSelect.remove(0);
                }

                //Loop through each timeslot sent over
                let currentTimeCheck = false;
                data.time_slots.forEach((timeSlot) =>{
                    let isCurrentTime = false,
                    today = new Date(),
                    hourToCheck = timeSlot.split(':')[0];

                    //Check to see if it's the 'current' time
                    if(hourToCheck > today.getHours() && !currentTimeCheck){
                        isCurrentTime = true;
                        currentTimeCheck = true;
                    }else{
                        isCurrentTime = false;
                    }

                    let timeSlotOption = new Option(timeSlot,timeSlot,isCurrentTime,isCurrentTime);

                    timeSelect.add(timeSlotOption);
                });


                this.bwElement.querySelector('#party_size').classList.remove('disabled');
                this.bwElement.querySelector('#date').classList.remove('disabled');
                this.bwElement.querySelector('#time').classList.remove('disabled');

            })
            .catch((error) => {
                 this.bwElement.classList.remove('loading');
                console.error(error);
            }); 
        });
    }//end getGuestsAndTimes


    startTimer = (duration, display) => {
        
        var start = Date.now(),
            diff,
            minutes,
            seconds;
        
        var timer = setInterval(() => {
            diff = duration - (((Date.now() - start) / 1000) | 0);

            minutes = (diff / 60) | 0;
            seconds = (diff % 60) | 0;

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;

            display.textContent = minutes + ":" + seconds; 

            let confirmationScreen = document.querySelector('#confirmation-screen');
            let experiencesScreen = document.querySelector('#experiences-screen');
            let bookingTypeScreen = document.querySelector('#booking-type-screen');
            let otherAvailabilityScreen = document.querySelector('#other-availability-screen');
            let availabilitySearchScreen = document.querySelector('#availability-search-screen');

            if (confirmationScreen.classList.contains('active') || experiencesScreen.classList.contains('active') || experiencesScreen.classList.contains('active') || otherAvailabilityScreen.classList.contains('active') || availabilitySearchScreen.classList.contains('active')) {
                clearInterval(timer);
                this.addOnData = [];
            }

            if (diff <= 0) {
                start = Date.now() + 1000;
                this.reset = true;
                clearInterval(timer);
                this.addOnData = [];
                this.showBookingScreen('availability-search-screen');
            }
        }, 1000);
    }//end startTimer


    //Reset widget to initial state
    resetBookingWidget = () => {

        const bookingScreens = this.bwElement.querySelectorAll('.booking-screen');
        bookingScreens.forEach(bookingScreen => {
            bookingScreen.classList.remove('active');
        });

        // Reset HTML elements
        document.getElementById('availability-search-screen').classList.add('active');
        document.getElementById('ot-steps').style.display = 'block';
        document.getElementById('step-1').classList.add('active');
        document.getElementById('step-2').classList.remove('active');
        document.getElementById('step-3').classList.remove('active');
        document.getElementById('step-4').classList.remove('active');
        document.querySelector('.js-ot-title').style.display = 'block';
        document.querySelector('.js-ot-text').style.display = 'block';

        const resetForm = () => {
            const inputsToReset = ['restaurant_rid', 'party_size', 'time', 'first_name', 'last_name', 'telephone_number', 'email_address', 'card_number', 'exp_year', 'exp_month', 'cvc'];
            const today = new Date();

            inputsToReset.forEach(inputId => {
                const inputElement = document.getElementById(inputId);      
                if(inputId == 'party_size' || inputId == 'time') {
                    inputElement.innerHTML = '<option value="" disabled selected>Please select</option>';
                    inputElement.classList.add('disabled');
                } else if(inputId == 'exp_month') {
                    inputElement.value = '1';
                } else if(inputId == 'exp_year') {
                    inputElement.value = today.getFullYear();
                } else {
                    inputElement.value = '';
                }
            });

            const formattedDate = `${today.getFullYear()}-${('0' + (today.getMonth() + 1)).slice(-2)}-${('0' + today.getDate()).slice(-2)}`;
            const dateInput = document.getElementById('date');
            dateInput.value = formattedDate;
            dateInput.classList.add('disabled');
        };

        resetForm();

        // reset all variables as we return back to first screen
        this.restaurantRid = '';
        this.partySize = '';
        this.startDateTime = '';
        this.cardRequired = '';
        this.attributes = '';
        this.reservationAttribute = '';
        this.availabilityType = '';
        this.experiences = '';
        this.chosenExperience = 'not-set';
        this.chosenExperienceName = 'not-set';
        this.addOnData = [];
        this.submitted = false;

        if(this.buttonActive == true) {
            this.reset = true;
        }
        
    }


}//end igOtBooking Classa
